export class ButtonAxisActivator {
    constructor(element, buttonPrefix, onActivate) {
        this.down = buttonPrefix + "down";
        this.up = buttonPrefix + "up";
        this.pressed = false;
        this.onActivate = onActivate;
        this.el = element;

        this.onButtonDown = this.onButtonDown.bind(this);
        this.onButtonUp = this.onButtonUp.bind(this);
        this.onAxisMove = this.onAxisMove.bind(this);

        element.addEventListener(this.down, this.onButtonDown);
        element.addEventListener(this.up, this.onButtonUp);
        element.addEventListener("axismove", this.onAxisMove);
    }

    onAxisMove(event) {
        if (this.pressed) {
            this.onActivate(event);
        }
    }

    onButtonDown() {
        this.pressed = true;
    }

    onButtonUp() {
        this.pressed = false;
    }

    removeListeners() {
        this.el.removeEventListener(this.down, this.onButtonDown);
        this.el.removeEventListener(this.up, this.onButtonUp);
        this.el.removeEventListener("axismove", this.onAxisMove);
    }
}
